import { createGlobalStyle } from 'styled-components';
import PinIcon from '../images/pin-icon.jpg';
import PinIconHover from '../images/pin-icon-hover.jpg';

/* ---------------------------------------------------------
 AVOID PUTTING ANTHING HERE UNLESS ABOLUTELY NECESSARY

  All class styles should be associated with their component
  in a *componentname*Styled.js file and imported
 -----------------------------------------------------------*/

const GlobalStyle = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    box-sizing:border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  

  /* Required for externally loaded google results elements */
  .pac-item:hover
  {
    background-color: ${(props) => props.theme.colors.buttons.textLink};
    color: white ;
  }

  .pac-item:hover .pac-item-query
  {
    color: white;
  }

  .pac-item:hover .pac-icon
  {
    background-image: url(${PinIconHover}) !important;
  }

  .pac-container
  {
    width: 314px !important;
    margin-left: -40px;
  }

  .pac-icon
  {
    background-image: url(${PinIcon}) !important;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 12px;
    height: 17px;
    margin-left:20px;
    margin-right:25px;
    background: transparent;
  }

  .pac-item-query
  {
    font-family: ${(props) => props.theme.fonts[3]};
  }

  @media screen and (min-width: 1023px) 
  {
    .pac-container
    {
      width: 391px !important;
      margin-left: -40px;
    }
  }

  
  
  body {
    font: 18px ${(props) => props.theme.fonts[1]}, 'serif';
    line-height: 38px;
    color: ${(props) => props.theme.colors.texts.shipGrey};
    background-color: ${(props) => props.theme.colors.backgrounds.sand};

    @media screen and (min-width: 768px) {
      font-size: 20px;
      line-height: 42px;
    }

    h1,
    h2,
    h3,
    h4,
    h5 {
      font-family: ${(props) => props.theme.fonts[0]}, sans-serif;
    }
  }
`;

export default GlobalStyle;
